import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Healthcare', href: '#healthcare' },
  { label: 'Product & Design', href: '#design' },
  { label: 'Writing', href: '#writing' },
];

const REACHLY_URL = 'https://reachly.sarahzhou.com';

const Header: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed w-full glass-effect z-50">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-12">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="text-lg font-bold text-ink-700 tracking-tight">
            Sarah Zhou
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center space-x-7 text-sm font-medium">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-ink-500 hover:text-blush-500 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href={REACHLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-1.5 rounded-full bg-sky-100 text-sky-500 hover:bg-sky-200 transition-colors font-semibold"
            >
              Reachly ↗
            </a>
          </nav>

          {/* Mobile toggle */}
          <button
            type="button"
            onClick={() => setOpen((o) => !o)}
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            className="md:hidden flex items-center justify-center w-11 h-11 -mr-2 text-ink-700"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile dropdown */}
        {open && (
          <nav className="md:hidden flex flex-col pb-4 text-sm font-medium">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-2.5 text-ink-600 hover:text-blush-500 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href={REACHLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex w-max px-4 py-1.5 rounded-full bg-sky-100 text-sky-500 hover:bg-sky-200 transition-colors font-semibold"
            >
              Reachly ↗
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
